module.exports = __webpack_public_path__ + "img/jacket-right-sub-setIn-hood.0ddbde58.png";